import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { featuresAndUserQuery } from 'queries';
import { featureFlag } from 'config';

const { overrides, defaults } = featureFlag;

export default new AsyncActionHandler({
  name: 'fetch_features_and_user',
  stateProp: 'features',
  defaultState: {
    currentUser: {},
    features: {
      flags: defaults,
      complete: false
    }
  },
  handler() {
    return async () => {
      const {
        data: { features, currentUser }
      } = await apollo.query({
        query: featuresAndUserQuery
      });

      // Defaults to flags set in code but otherwise uses what
      // the server sets.
      // The flags are sent as an array of { name, enabled, value } and is
      // converted to an object with name as the key and either enabled or value
      // as the fields value
      let flags = defaults;
      if (features && features.length > 0) {
        flags = features.reduce(
          (features, { name, enabled, value }) => {
            features[name] = enabled && value !== null ? value : enabled;
            return features;
          },
          { ...flags }
        );
      }

      if (overrides) {
        flags = {
          ...flags,
          ...overrides
        };
      }

      return {
        currentUser,
        features: {
          flags,
          complete: true
        }
      };
    };
  },
  reduce(state, { features, currentUser }) {
    return {
      currentUser,
      [this.stateProp]: {
        ...features
      }
    };
  }
});
